import Link from '@amzn/meridian/link';
import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import viewPO1 from '../../../assets/help/viewPurchaseOrders/view_po_1.png';
import viewPO2 from '../../../assets/help/viewPurchaseOrders/view_po_2.png';
import viewPO3 from '../../../assets/help/viewPurchaseOrders/view_po_3.png';
import { SiteHelpCallback } from '../../../constants';
import { useTranslation } from '../../blocks';
import { HelpBody, HelpBullet, HelpImage, HelpIndent, HelpSubheading, HelpTitle } from './HelpElements';

const ViewPurchaseOrdersHelp: FC<SiteHelpCallback> = () => {
    const { t } = useTranslation('viewPurchaseOrdersHelp');

    return (
        <>
            <HelpTitle>{t('viewPurchaseOrdersHelp_Title')}</HelpTitle>
            <HelpBody>{t('viewPurchaseOrdersHelp_step1')}</HelpBody>
            <HelpIndent>
                <HelpBullet>{t('viewPurchaseOrdersHelp_step1_returnsAdmin')}</HelpBullet>
                <HelpBullet>{t('viewPurchaseOrdersHelp_step1_poAdminGrant')}</HelpBullet>
                <HelpBullet>
                    <Trans
                        i18nKey={'viewPurchaseOrdersHelp_step1_noAdmin'}
                        ns={'viewPurchaseOrdersHelp'}
                        components={{ mailto: <Link href={'mailto:naso-core-team@amazon.com'}>{''}</Link> }}
                    />
                </HelpBullet>
            </HelpIndent>
            <HelpBody>{t('viewPurchaseOrdersHelp_step1_roleAdmin')}</HelpBody>
            <HelpIndent>
                <HelpBullet>{t('viewPurchaseOrdersHelp_step1_createUser')}</HelpBullet>
                <HelpBullet>{t('viewPurchaseOrdersHelp_step1_viewUser')}</HelpBullet>
            </HelpIndent>
            <HelpImage size={'medium'} src={viewPO1} />
            <HelpSubheading>{t('viewPurchaseOrdersHelp_step2')}</HelpSubheading>
            <HelpIndent>
                <HelpBullet>{t('viewPurchaseOrdersHelp_step2_navigate')}</HelpBullet>
            </HelpIndent>
            <HelpImage size={'xlarge'} src={viewPO2} />
            <HelpSubheading>{t('viewPurchaseOrdersHelp_step3')}</HelpSubheading>
            <HelpBody>{t('viewPurchaseOrdersHelp_step3_intro')}</HelpBody>
            <HelpIndent>
                <HelpBullet>{t('viewPurchaseOrdersHelp_step3_poIds')}</HelpBullet>
                <HelpBullet>{t('viewPurchaseOrdersHelp_step3_unitStatus')}</HelpBullet>
                <HelpIndent>
                    <HelpBullet level={1}>{t('viewPurchaseOrdersHelp_step3_unitStatus_open')}</HelpBullet>
                    <HelpBullet level={1}>{t('viewPurchaseOrdersHelp_step3_unitStatus_released')}</HelpBullet>
                    <HelpBullet level={1}>{t('viewPurchaseOrdersHelp_step3_unitStatus_shipped')}</HelpBullet>
                    <HelpBullet level={1}>{t('viewPurchaseOrdersHelp_step3_unitStatus_cancelled')}</HelpBullet>
                </HelpIndent>
                <HelpBullet>{t('viewPurchaseOrdersHelp_step3_asin')}</HelpBullet>
                <HelpBullet>{t('viewPurchaseOrdersHelp_step3_retailerSku')}</HelpBullet>
                <HelpBullet>{t('viewPurchaseOrdersHelp_step3_family')}</HelpBullet>
                <HelpBullet>{t('viewPurchaseOrdersHelp_step3_shipToLocation')}</HelpBullet>
                <HelpBullet>{t('viewPurchaseOrdersHelp_step3_dates')}</HelpBullet>
                <HelpIndent>
                    <HelpBullet level={1}>{t('viewPurchaseOrdersHelp_step3_dates_creation')}</HelpBullet>
                    <HelpBullet level={1}>{t('viewPurchaseOrdersHelp_step3_dates_requestedShip')}</HelpBullet>
                    <HelpBullet level={1}>{t('viewPurchaseOrdersHelp_step3_dates_requestedDelivery')}</HelpBullet>
                </HelpIndent>
                <HelpBullet>{t('viewPurchaseOrdersHelp_step3_columns')}</HelpBullet>
            </HelpIndent>
            <HelpSubheading>{t('viewPurchaseOrdersHelp_step4')}</HelpSubheading>
            <HelpBody>{t('viewPurchaseOrdersHelp_step4_intro')}</HelpBody>
            <HelpIndent>
                <HelpBullet>{t('viewPurchaseOrdersHelp_step4_clickPO')}</HelpBullet>
                <HelpBullet>{t('viewPurchaseOrdersHelp_step4_summary')}</HelpBullet>
                <HelpBullet>{t('viewPurchaseOrdersHelp_step4_export')}</HelpBullet>
            </HelpIndent>
            <HelpSubheading>{t('viewPurchaseOrdersHelp_step5')}</HelpSubheading>
            <HelpBody>{t('viewPurchaseOrdersHelp_step5_intro')}</HelpBody>
            <HelpImage size={'xlarge'} src={viewPO3} />
            <HelpIndent>
                <HelpBullet>{t('viewPurchaseOrdersHelp_step5_clickExport')}</HelpBullet>
                <HelpBullet>{t('viewPurchaseOrdersHelp_step5_definitions')}</HelpBullet>
                <HelpBullet>{t('viewPurchaseOrdersHelp_step5_tracking')}</HelpBullet>
                <HelpIndent>
                    <HelpBullet level={1}>
                        <Trans
                            i18nKey={'viewPurchaseOrdersHelp_step5_tracking_azng'}
                            ns={'viewPurchaseOrdersHelp'}
                            components={{ mailto: <Link href={'mailto:naso-core-team@amazon.com'}>{''}</Link> }}
                        />
                    </HelpBullet>
                </HelpIndent>
            </HelpIndent>
            <HelpSubheading>{t('viewPurchaseOrdersHelp_step6')}</HelpSubheading>
            <HelpIndent>
                <HelpBullet>
                    <Trans
                        i18nKey={'viewPurchaseOrdersHelp_step6_contact'}
                        ns={'viewPurchaseOrdersHelp'}
                        components={{ mailto: <Link href={'mailto:naso-core-team@amazon.com'}>{''}</Link> }}
                    />
                </HelpBullet>
            </HelpIndent>
        </>
    );
};

export { ViewPurchaseOrdersHelp };
